export default class Profile {
  constructor() {
    this.accountStatus = null;
    this.birthDay = null;
    this.contactInfo = {
      email1: null,
      phone1: null,
      phone2: null,
    };
    this.emailVerified = null;
    this.emailVerify = null;
    this.email_verified = null;
    this.firstName = null;
    this.lastFour = null;
    this.lastName = null;
    this.loginId = null;
    this.officeId = null;
    this.riaGroupId = null;
    this.riaId = null;
    this.riaTitle = null;
    this.riaUserId = null;
    this.riaUserTypeId = null;
    this.role = null;
    this.settingsEmailStatus = null;
    this.settingsTempEmail = null;
    this.userAvatar = null;
    this.userCrdNumber = null;
    this.userUploadedAvatar = null;
    this.userCrdNumber = null;
  }
}
